<h2 class="text-center"> Worksheet Request List</h2>
<div class="table-responsive" *ngIf="!loading">
  <table datatable  [dtOptions]="dtOptions" class="table table-striped display compact" id="assetTable">
    <thead>
    <tr>

        <th>Quiz Id</th>
        <th>Level</th>
        <th>subject</th>
        <th>Date Requested</th>
        <th>Date Downloaded</th>
        <th>Email</th>
        <th>View</th>

    </tr>
    </thead>

    <tbody>

        <tr *ngFor="let worksheet of worksheets;">

        <td>{{worksheet.id}}</td>
        <td>{{worksheet.levelName}}</td>
        <td>{{worksheet.subjectName}}</td>

        <td>{{worksheet.dateCreated}}</td>
        <td>{{worksheet.dateDownloaded}}</td>
        <td>{{worksheet.email}}</td>
        <td><button (click)="viewFreeWorkBook(worksheet.code,worksheet.id)">

          <i *ngIf="!(downloading && (idRequest==worksheet.id))" class='fa fa-file-pdf-o'></i>
          <span *ngIf="(downloading && (idRequest==worksheet.id))" class="spinner-border spinner-border-lg me-1 text-primary"></span>


          </button></td>


    </tr>

    </tbody>

</table>
</div>
<app-empty [isEmpty]="isEmpty"></app-empty>
<app-loading [loading]="loading"></app-loading>
